export default "__VITE_ASSET__2sUiLS4t__"